<template>
  <div id="app">
    <Header v-if="this.$route.fullPath !== '/administer'"></Header>
    <router-view></router-view>
  </div>
</template>

<script>
import Header from './base/Header'
import Footer from './base/Footer'
export default {
  name: 'app',
  components: {
      Footer,
      Header
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  margin: 0 auto;
  background: #f1f1f1;
  min-width: 1280px;
  /*background: radial-gradient(rgba(192, 232, 244, 0.43), rgba(193, 199, 231, 0.22))*/
}
</style>
